import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    user: {},
    isAuthenticated: false,
    session_id: ''
};

export const authSlice = createSlice({
    initialState,
    name: 'user',
    reducers: {
        setUser: (state, action) => {
            state.user = action.payload;
            state.isAuthenticated = true;
            state.session_id = localStorage.getItem('session_id');

            localStorage.setItem('accountId', action.payload.id);

        }
    }

});
export const { setUser } = authSlice.actions;
export default authSlice.reducer;
export const userSelector = (state) => state.user;